import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
import { serviceUrl } from '../../App';

export const addusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `auth/register`, obj, {
    headers,
  });
};
export const editusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `auth/edit`, obj, {
    headers,
  });
};
export const deleteusers = (obj: Object, token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `auth/delete-users`,
    obj,
    { headers }
  );
};
export const forgetPassword = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `auth/forget-password`,
    obj,
    { headers }
  );
};
export const getusers = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `auth/users`);
};
export const setActiveOrganization = (active_organization_ids: number[], token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `auth/active-organization`,
    { active_organization_ids },
    { headers }
  );
};

export const getMyOrganizations = (token: string) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(GetBackendUrlForGlobalFunctions() + `auth/my-organizations`, { headers });
};

export async function initDefaultOrganization(token: string): Promise<void> {
  const hasStoredSelection =
    localStorage.getItem('selectedOrgIds') !== null ||
    localStorage.getItem('selectedOrgId') !== null;
  if (hasStoredSelection) return;

  const res: any = await getMyOrganizations(token);
  const first = res?.data?.[0];
  if (!first) return;

  const id = first.organization_id;
  const name =
    first.organization_code || first.name || first.organization_name ||
    first.department_name || first.company_name || `Org #${id}`;

  localStorage.setItem('selectedOrgIds', JSON.stringify([id]));
  localStorage.setItem('selectedOrgName', name);
  await setActiveOrganization([id], token);
}